import JSEncrypt from "jsencrypt"



const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0Yig6bfM4eq1XvJCM4Jn\n' +
  'SQ8F1XAjEj8NT7Z+Lm/axdJAA9Qi5dDlYQBucuMz7aq1Vp6sPIJtXd/nwUHMQ53D\n' +
  'L4Ix3Oefj5cno4k7HLi8iKDj3edzLYXqToX+PSrJJTgG2ESI+dyVcDmh6uX0qSPX\n' +
  'iMPZqNh/AwnqZJTydLWaOQbddkO8dKPUW1zVXFoHPl1VpQeDvKrNyV34ZaBtu/O+\n' +
  'CU7dC6xOEWxZ51lU/8tXx96pxpzktQsq4x4PXwDw2r/PqeB4bDgIEjLVZoAXy7AI\n' +
  'k/El2EjIEpzzWy4vvEzTmyX7lrt/KMv3xM6SoqcQ4P9s48RqbBibI2ARaVmNK26C\n' +
  'kwIDAQAB'


// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}


